import { useSwipeable } from 'react-swipeable';
import { useNavigate } from 'react-router-dom';

const Dessert = ({ language }: { language: string }) => {

  const navigate = useNavigate();

  // Configuration améliorée du swipe
  const handlers = useSwipeable({
    onSwipedLeft: () => {
      navigate('/Drinks');
    },
    onSwipedRight: () => {
      navigate('/Kids');
    },
    trackMouse: true,
    delta: 50, // Distance minimale pour déclencher le swipe
    trackTouch: true
  });




  return (
    <div
      {...handlers} // Attachez les gestionnaires d'événements au div
      className="min-h-screen flex flex-col items-center p-8 bg-cover bg-center bg-fixed pt-[110px]"
      style={{ backgroundImage: "url('/image/Lona2.jpg')" }}>

      <p className="text-center text-xs text-green-950 mt-2">
        {language === "fr" ? "Glissez pour naviguer" : "Swipe to navigate"}
      </p>
      
      <div className="bg-white/80 backdrop-blur-sm rounded-xl p-8 max-w-2xl w-full shadow-lg mt-8">
        <ul className="space-y-2">
          {[
           
            [
              "Souvenir de Grand-Maman",
              "Grandma's Memory",
              "16$",
              "$16",
              "Beignet moelleux imprégné de miel, préparé avec tout l’amour des recettes de ma grand-mère.",
              "Soft donut infused with honey, made with all the love from my grandmother's recipes."
            ],
            [
              "Pancakes aux fruits",
              "Fruit Pancakes",
              "14$",
              "$14",
              "Pancakes moelleux, délicatement dorés, servis avec du sirop d'érable et accompagnés de fruits frais de saison pour une touche de fraîcheur.",
              "Fluffy, golden pancakes served with maple syrup and accompanied by fresh seasonal fruits for a refreshing touch."
            ]
          ].map(([fr, en, prixFr, prixEn, descFr, descEn], index) => (
            <li key={index} className="pb-6 border-b border-gray-200 last:border-0">
              <div className="flex justify-between">
                <div>
                  <h3 className="font-bold text-lg">{language === "fr" ? fr : en}</h3>
                  <p className="text-gray-600 text-sm mt-1">
                    {language === "fr" ? descFr : descEn}
                  </p>
                </div>
                <span className="text-green-950 font-medium">
                  {language === "fr" ? prixFr : prixEn}
                </span>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Dessert;